import {useMutation} from '@tanstack/react-query';
import Api from '../api/Api';
import { IPreprocessedAnalyticsPayload } from '../types/chart';
import {MUTATION_KEYS} from "./queryKeys";

type Options = {
  onSuccess?: (data: any) => void;
  onError?: (error: Error) => void;
}

export const useGetPreprocessedAnalyticsMutation = (options?: Options) => {
  return useMutation({
    mutationKey: [MUTATION_KEYS.chart.preprocessedAnalytics],
    mutationFn: async (payload: IPreprocessedAnalyticsPayload): Promise<any[]> => {
      const result = await Api.chart.getPreprocessedAnalytics(payload);

      if (!result) {
        throw new Error('No result returned');
      }

      if (result.Error) {
        throw new Error(
          result.Error.ErrorMessage || 'Failed to fetch preprocessed analytics'
        );
      }

      return result.Result;
    },
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
};
